import { render } from "./DesignSetting.vue?vue&type=template&id=588c9bc0&scoped=true"
import script from "./DesignSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./DesignSetting.vue?vue&type=script&setup=true&lang=js"

import "./DesignSetting.vue?vue&type=style&index=0&id=588c9bc0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588c9bc0"],['__file',"src/pages/scada/DesignSetting/DesignSetting.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "588c9bc0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('588c9bc0', __exports__)) {
    console.log('reload')
    api.reload('588c9bc0', __exports__)
  }
  
  module.hot.accept("./DesignSetting.vue?vue&type=template&id=588c9bc0&scoped=true", () => {
    console.log('re-render')
    api.rerender('588c9bc0', render)
  })

}


export default __exports__